<template>
  <section class="section-padding-gray">
    <h2 class="text-center">{{ $t('message.menu.promotions') }}</h2>
    <div class="row">
      <template v-for="promotion in promotions">
        <div class="col-sm-4 p-4 pointer-item" @click="openUrl(promotion)">
          <img :src="promotion.image_sm" alt="" class="img-fluid rounded">
        </div>
      </template>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import userEventLogHelpers from '../../helpers/userEventLogHelpers'
  
  export default {
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      }),
      ...mapState('promotion', ['promotions'])
    },
    methods: {
      openUrl (promotion) {
        if (promotion.landing_page === 'promotion_detail') {
          this.$router.push(`/promotions/${promotion.id}`)
        } else {
          // Save user event log
          userEventLogHelpers.logEvent('view_promotion', {
            promotion_id: promotion.id
          })
          // Open promotion url
          let url = promotion.page_url
          if (promotion.is_dynamic_url === 1 && this.user) {
            url += '?user_id=' + this.user.id
          }
          window.open(url, '_blank')
        }
      }
    },
    mounted () {
      let queryData = null
      if (this.user) {
        queryData = {
          params: {
            user_id: this.user.id
          }
        }
      }
      this.$store.dispatch('promotion/LOAD_PROMOTIONS', queryData)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/promotion/Index.vue